<template>
  <BaseLayout>
    <div class="cardLawyer">
      <div class="header">
        <span>点击右上角</span>
        <img class="m-l-10 m-r-20 rightTopImage" src="@/view/card/assets/right-top.png" />
        <span>分享给律所成员</span>
        <img class="shareImage" src="@/view/card/assets/share.png" />
        <img class="rightTopArrowImage" src="@/view/card/assets/right-top-arrow.png" />
      </div>
      <div class="card box-shadow">
        <!-- <img class="card-bg" src="./assets/card-bg.png"> -->

        <div class="f-column f-center w-100b">
          <div class="flex w-100b f-start m-b-40 f-y-center">
            <img
              v-if="orgAvatarUrl && orgAvatarUrl"
              class="orgAvatarImage m-l-60"
              :src="orgAvatarUrl"
            />
            <div v-else class="defaultOrgAvatarImage m-l-60">{{orgName?.substr(0,1)}}</div>
            <div class="orgName m-l-10">{{urlQuery.orgName}}</div>
          </div>
          <img v-if="avatarUrl && avatarUrl" class="avatarImage m-b-40" :src="avatarUrl" />
          <div v-else class="defaultAvatarImage m-b-40">{{userName?.substr(0,1)}}</div>
          <div class="title m-b-10">{{urlQuery.userName}}</div>
          <div class="title-small">{{urlQuery.mobile}}</div>
        </div>
        <div class="f-column f-center">
          <div class="label-1">法律服务</div>
          <div class="label-2">金融合同纠纷、刑事辩护、刑事辩护、债权债务</div>
        </div>
      </div>
      <div class="flex m-t-60 m-l-30 m-r-30">
        <ion-button class="f-1" color="primary" @click="toRegistered">注册并关注我的案件</ion-button>
      </div>
    </div>
  </BaseLayout>
</template>

<script>
import { ref, onBeforeMount } from 'vue'
import router from '@/router'
import { getUrlQuery, isUrl, serverUrl } from '@/utils/url.js'
import { fileApi } from '@/apis'

export default {
  setup() {
    document.getElementsByTagName('title')[0].innerText = '律师名片'
    const avatarUrl = ref('')
    const orgAvatarUrl = ref('')
    const urlQuery = getUrlQuery()
    const orgName = urlQuery.orgName || ''
    const userName = urlQuery.userName || ''
    const toRegistered = () => {
      router.push({
        path: '/registered',
        query: { userType: 'individual', ...urlQuery },
      })
    }
    onBeforeMount(async () => {
      if (urlQuery.img) {
        avatarUrl.value = await fileApi.getValidUrl({
          id: Number(urlQuery.img),
        })
      }
      if (urlQuery.orgIconUrl) {
        orgAvatarUrl.value = await fileApi.getValidUrl({
          id: Number(urlQuery.orgIconUrl),
        })
      }
    })
    return {
      toRegistered,
      urlQuery,
      avatarUrl,
      orgAvatarUrl,
      orgName,
      userName,
    }
  },
}
</script>

<style lang="scss">
.cardLawyer {
  .header {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 40px;
    width: 100%;
    height: 160px;
    background: #ffffff;
    font-size: 28px;
    color: #999;
    .rightTopImage {
      width: 64;
      height: 40px;
    }
    .shareImage {
      width: 88px;
      height: 88px;
    }
    .rightTopArrowImage {
      width: 154px;
      height: 100px;
      position: absolute;
      top: 0;
      right: 28px;
    }
  }
  .defaultOrgAvatarImage {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    font-size: 28px;
    color: #fff;
    background-color: #e6a23c;
    background-color: #e6a23c;
  }
  .orgAvatarImage {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .defaultAvatarImage {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 200px;
    height: 200px;
    border-radius: 50%;
    font-size: 56px;
    color: #fff;
    background-color: #e6a23c;
  }
  .avatarImage {
    width: 200px;
    height: 200px;
    border-radius: 50%;
  }

  .orgName {
    font-size: 24;
    color: #fff;
  }

  .card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    position: relative;
    margin: 0px 40px;
    padding: 40px 0 60px;
    width: 670px;
    height: 806px;
    background-image: url('./assets/lawyer-bg.png');
    background-size: 670px 806px;
    .title {
      font-size: 36px;
      color: #fff;
    }
    .title-small {
      font-size: 28px;
      color: #fff;
    }
    .label-1 {
      font-size: 28px;
      color: #555;
    }
    .label-2 {
      font-size: 28px;
      color: #999;
    }
    .card-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      // height: 500px;
    }
  }
}
</style>